import random from 'toxilibs/random.js'
import Level from '../core/level.js'

const level = new Level({
    name: 'proportionality_negatives',
    dependencies: [
        'levels_maths/proportionality_inverted'
    ]
})


function niceFloat (value) {
    return Math.round(value * 100) / 100
}


function common (q, value, countA, countB) {
    q.addText(countA + ' -> ' + (countA * value))
    q.addText(countB + ' -> ANSWER_HERE')
    q.answer = countB * value

    q.addBadChoices(
        niceFloat(countA * countB * value),
        niceFloat(countA * countA * value),
        () => {
            let x = niceFloat(random.intBetween(1, Math.max(countA, countB) + 1) * value)
            return random.oneChanceIn(2) ? x : -x
        },
        () => {
            let x = random.intBetween(1, (Math.max(countA, countB, 4) + 1) * Math.max(2, value))
            return random.oneChanceIn(2) ? x : -x
        }
    )
}


level.addQuestion({
    generator: function (q) {
        let value = random.fairChoice([-2, -3, -10, -11, -20, -100], {name: 'value'})
        let count = random.fairChoice([2, 3, 4], {name: 'count'})
        common(q, value, 1, count)
    }
})


level.addQuestion({
    generator: function (q) {
        let value = random.fairChoice([-2, -3, -10, -11, -20, -100], {name: 'value'})
        let countA = random.fairChoice([3, 4], {name: 'countA'})
        let countB = random.fairChoice([1, 2], {name: 'countB'})
        common(q, value, countA, countB)
    }
})


level.addQuestion({
    generator: function (q) {
        q.smartChoose([
            {1:   {countA: 4, countB: -1, value: -2}},
            {1:   {countA: 3, countB: -2, value: -3}},
            {all: {countA: [3, 4], countB: [-1, -2], value: [-2, -3, -10, -11, -20, -100]}}
        ], function (choices) {
            common(q, choices.value, choices.countA, choices.countB)
        })
    },
    times: 2
})



export default level

